export default {
	envelopeList: {
		item_count: 0,
		list: [],
		total_count: 0
	},
	envelopeInfo: {},
	envelopeShopList: {
		total_count: 0,
		list: [],
		shop_list: []
	},
	envelopeRecordList: {
		item_count: 0,
		list: [],
		total_count: 0
	},
	shopEnvelopeRecordList: {
		item_count: 0,
		list: [],
		total_count: 0
	}
}



// WEBPACK FOOTER //
// ./src/store/mp/marketing/envelope/state.js